import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dc7555f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "report-submit"
}
const _hoisted_2 = { class: "report-submit__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "report-submit__content-title" }, "Отправить отчёт", -1))
const _hoisted_4 = {
  key: 0,
  class: "report-submit__content-info"
}
const _hoisted_5 = {
  key: 1,
  class: "report-submit__content-info"
}
const _hoisted_6 = { class: "report-submit__footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Отправлять с файлами из комментариев ")

import { computed, PropType, ref } from 'vue'
import { useRoute } from 'vue-router'
import { FSubmitReport } from '@/features/FSubmitReport'
import { ReportViewType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  email: String,
  reportType: String as PropType<ReportViewType>,
  hideCommentFilesCheckbox: Boolean,
},
  setup(__props) {

const props = __props



const route = useRoute()
const sendCommentFiles = ref(false)
const hasEmail = computed(() => Boolean(props.email))

const reportId = computed(() => Number(route.params.reportId))

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_unref(reportId))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_unref(hasEmail))
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Отчёт будет отправлен пациенту на эл. почту " + _toDisplayString(__props.email), 1))
            : _createCommentVNode("", true),
          (!_unref(hasEmail))
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " У пациента не назначена эл. почта "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(FSubmitReport), {
            "report-type": __props.reportType,
            "report-id": _unref(reportId),
            "send-comment-files": sendCommentFiles.value,
            enabled: _unref(hasEmail)
          }, null, 8, ["report-type", "report-id", "send-comment-files", "enabled"]),
          (!__props.hideCommentFilesCheckbox)
            ? (_openBlock(), _createBlock(_component_el_checkbox, {
                key: 0,
                modelValue: sendCommentFiles.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sendCommentFiles).value = $event)),
                disabled: !_unref(hasEmail)
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})